// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/design-manoeuvring-speed-va.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/design-manoeuvring-speed-va/design-manoeuvring-speed-va-gust.js';
import g1 from '../lessons/aeronautics/design-manoeuvring-speed-va/design-manoeuvring-speed-va.js';

mount([g0, g1]);
